module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_5010.c3ec4406.png";